import { render, staticRenderFns } from "./StudentMove.vue?vue&type=template&id=2f9236b0&scoped=true&"
import script from "./StudentMove.vue?vue&type=script&lang=js&"
export * from "./StudentMove.vue?vue&type=script&lang=js&"
import style0 from "./StudentMove.vue?vue&type=style&index=0&id=2f9236b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9236b0",
  null
  
)

export default component.exports